// extracted by mini-css-extract-plugin
module.exports = {"title":"index-module--title--TopJ7","altTitle":"index-module--altTitle--1UTtd","item":"index-module--item--3XLdR"};